import { makeAutoObservable } from 'mobx'

export class UIStore {
  public loading = false

  constructor() { makeAutoObservable(this) }
}
